import { useState, useEffect } from 'react';
import { getBNClosingBalances } from "../../../networking/NetworkingOrders";

export const useClosingBalancesData = (params) => {
  const [columnsData, setColumnsData] = useState([]);
  const [columnDetail, setColumnDetail] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const response = await getBNClosingBalances(params);

      if (response && response.result) {
        let parsedColumnDetail = {};
        if (response.columnDetail) {
          try {
            const columnDetailObj = JSON.parse(response.columnDetail);
            parsedColumnDetail = Object.keys(columnDetailObj).reduce((acc, key) => {
              const value = columnDetailObj[key];
              const titleMatch = value.match(/title:([^,]+)/);
              const widthMatch = value.match(/width:([^,]+)/);
              acc[key] = {
                title: titleMatch ? titleMatch[1] : key,
                width: widthMatch ? widthMatch[1] : 'auto'
              };
              return acc;
            }, {});
          } catch (e) {
            console.error('Error parsing columnDetail:', e);
          }
        }

        const mappedData = response.result;

        setColumnDetail(parsedColumnDetail);
        setColumnsData(mappedData);
      }
    };

    fetchData();
  }, [params]);

  return { columnsData, columnDetail };
};